import { fireErrorAnalytics } from '@atlassian/ui-modifications-analytics';
import { getViewConfiguration } from './store';
var isKeyOf = function isKeyOf(key, object) {
  return object[key] !== undefined;
};
var getConfigurationByViewType = function getConfigurationByViewType(_ref) {
  var viewType = _ref.viewType;
  var viewConfiguration = getViewConfiguration(viewType);
  if (!viewConfiguration) {
    throw new Error("Unsupported view type ".concat(viewType, " in getConfigurationByViewType."));
  }
  return viewConfiguration;
};
export function getSupportedFieldConfiguration(viewType, fieldType) {
  var fieldsConfiguration = getConfigurationByViewType({
    viewType: viewType
  }).getSupportedFieldsConfiguration();
  if (!isKeyOf(fieldType, fieldsConfiguration)) {
    fireErrorAnalytics({
      error: new Error('Unsupported field type.'),
      id: 'getSupportedFieldConfiguration',
      viewType: viewType,
      attributes: {
        fieldType: fieldType
      }
    });
    return undefined;
  }
  return fieldsConfiguration[fieldType];
}
export var getSupportedFieldTypes = function getSupportedFieldTypes(viewType) {
  return getConfigurationByViewType({
    viewType: viewType
  }).getSupportedFieldTypes();
};
export function isFieldTypeSupported(viewType, fieldType) {
  return fieldType !== undefined &&
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  getSupportedFieldTypes(viewType).includes(fieldType);
}
export function getConsentMessage(viewType) {
  return getConfigurationByViewType({
    viewType: viewType
  }).getConsentMessage();
}
export function isExecutionContextSupported(context) {
  return getConfigurationByViewType({
    viewType: context.viewType
  }).isExecutionContextSupported({
    context: context
  });
}
export function getAnalytics(viewType) {
  return getConfigurationByViewType({
    viewType: viewType
  }).getAnalytics();
}
export function getSupportedTriggerPointsConfiguration(viewType) {
  return getConfigurationByViewType({
    viewType: viewType
  }).getSupportedTriggerPointsConfiguration();
}
export var isTriggerPointSupported = function isTriggerPointSupported(viewType, triggerPoint) {
  return triggerPoint !== undefined && getSupportedTriggerPointsConfiguration(viewType).has(triggerPoint);
};